import React, { Fragment, useEffect } from 'react';
import { IntlProvider, FormattedNumber } from 'react-intl';
import './receipt.css';
import { MatxLoading } from '../../../components';
import useCredio from '../../../hooks/useCredio';
const Receipt = ({ data, banks, users, onCLick }) => {

  var { loadUserData, userData, getEachUser, } = useCredio();


  useEffect(() => {
    getEachUser(data.phoneNumber);
  }, []);



  console.log("banks -- ", banks, data.referenceData.sessionId.substring(0, 6));
  if (loadUserData) {
    return (
      <IntlProvider locale="en" defaultLocale="en">
        <div class="modal-content">
          <div class="container">
            <div class="header">
              <img
                src="https://media.licdn.com/dms/image/C4D0BAQEgRMjOAbjIFg/company-logo_200_200/0/1624933162683?e=2147483647&v=beta&t=Txh0IHnMoynKHn2QxqbK5mA8VGcwG2Pgl80cRD94SOM"
                alt="Logo"
              />
              <span id="close" class="close" onClick={onCLick}>
                &times;
              </span>
              <h2 class="h2D">
                {' '}
                <FormattedNumber value={data.amount} style="currency" currency="NGN" />
              </h2>
              <p>Transfer {data.status == 0 ? 'Successfully' : data.referenceData.responseMessage}</p>
            </div>
            <div class="content">
              <h3 class="headings">Transaction Details</h3>
              <div class="transaction-details">
                <div class="details space-between">
                  <div class="label">Transaction Amount</div>
                  <div class="value">
                    <FormattedNumber value={data.amount} style="currency" currency="NGN" />
                  </div>
                </div>

                <div class="details space-between">
                  <div class="label">Transaction Fees:</div>
                  <div class="value">
                    {' '}
                    <FormattedNumber value={data.fees} style="currency" currency="NGN" />
                  </div>
                </div>

                <div class="details space-between">
                  <div class="label">Transaction Type</div>
                  <div class="value">
                    {data.type == 1 ? 'Outgoing Transfer' : 'Incoming Transfer'}
                  </div>
                </div>
                <div class="details space-between">
                  <div class="label">Transaction ID</div>
                  <div class="value">{data._id}</div>
                </div>
                <div class="details space-between">
                  <div class="label">Remark</div>
                  <div class="value">{data.narration}</div>
                </div>
              </div>

              <h3 class="headings">Sender's Details</h3>
              <div class="beneficiary-details">
                <div class="details space-between">
                  <div class="label">Account Number</div>
                  <div class="value">
                    {data.type == 1
                      ? userData.vaults.accountNumber
                      : data.referenceData.debitAccountNumber}
                  </div>
                </div>
                <div class="details space-between">
                  <div class="label">Bank Name</div>
                  <div class="value">
                    {data.referenceData.providerChannel == 'CIP'
                      ? 'CREDIO'
                      : data.type == 1
                        ? 'CREDIO'
                        : (banks ?? []).find((element) => {
                          // console.log(
                          //   'element -- ',
                          //   element.bankCode,
                          //   data.referenceData.sessionId.substring(0, 6)
                          // );
                          return element.bankCode == data.referenceData.sessionId.substring(0, 6);
                        }).name ?? ''}
                  </div>
                </div>
                <div class="details space-between">
                  <div class="label">Account Name</div>
                  <div class="value">
                    {data.type == 1
                      ? userData.vaults.accountName
                      : data.referenceData.debitAccountName}
                  </div>
                </div>
              </div>
              <h3 class="headings">Beneficiary Details</h3>
              <div class="beneficiary-details">
                <div class="details space-between">
                  <div class="label">Account Number</div>
                  <div class="value">
                    {data.type == 0
                      ? userData.vaults.accountNumber
                      : data.referenceData.creditAccountNumber}
                  </div>
                </div>
                <div class="details space-between">
                  <div class="label">Bank Name</div>
                  <div class="value">
                    {' '}
                    {data.referenceData.providerChannel == 'CIP'
                      ? 'CREDIO'
                      : data.type === 0
                        ? 'CREDIO'
                        : (banks ?? []).find((element) => {
                          // console.log(
                          //   'element -- ',
                          //   element.bankCode,
                          //   data.referenceData.sessionId.substring(0, 6)
                          // );
                          return (
                            element.bankCode ==
                            data.referenceData.destinationInstitutionCode.substring(0, 6)
                          );
                        }).name ?? ''}
                  </div>
                </div>
                <div class="details space-between">
                  <div class="label">Account Name</div>
                  <div class="value">
                    {data.type == 0
                      ? userData.vaults.accountName
                      : data.referenceData.creditAccountName}
                  </div>
                </div>
              </div>
              <h3 class="headings">Status</h3>
              <div class="beneficiary-details">
                <div class="details space-between">
                  <div class="label">Response Code</div>
                  <div class="value">{data.referenceData.responseCode}</div>
                </div>
                <div class="details space-between">
                  <div class="label">Response Message</div>
                  <div class="value">{data.referenceData.responseMessage}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="print-button">
            <button class="print-btn">
              Print <span class=" fa-print"> </span>
            </button>
          </div>
        </div>
      </IntlProvider>
    );
  } else return <MatxLoading></MatxLoading>;
};

export default Receipt;
